import { gql } from '@apollo/client';

export const CREATE_ORDER_CAMPAIGN = gql`
    mutation ($orderid: MultiTypeInput, $campaignid: MultiTypeInput) {
        createRow(
            table: "order_campaign"
            values: [
                { property: "order_id", value: $orderid }
                { property: "campaign_id", value: $campaignid }
            ]
        )
    }
`;
